import { SprinklesElement } from "sprinkles-js";

export default class SelectAllElement extends SprinklesElement {
  static tagName = "select-all";
  static refs = ["trigger"];
  static events = { change: "handleChange" };

  afterConnected() {
    const items = this.querySelector(".select-group__items");
    if (items && this.refs.trigger.closest(".checkbox")) {
      items.prepend(this.refs.trigger.closest(".checkbox"));
    }
    this.updateTrigger();
  }

  get checkboxes() {
    return [...this.querySelectorAll('input[type="checkbox"]')].filter(
      (cb) => cb !== this.refs.trigger,
    );
  }

  handleChange(event) {
    if (event.target === this.refs.trigger) {
      this.checkboxes.forEach((cb) => (cb.checked = this.refs.trigger.checked));
    } else {
      this.updateTrigger();
    }
  }

  updateTrigger() {
    const cbs = this.checkboxes;
    const checkedCount = cbs.filter((cb) => cb.checked).length;
    this.refs.trigger.checked = checkedCount === cbs.length;
    this.refs.trigger.indeterminate =
      checkedCount > 0 && checkedCount < cbs.length;
  }
}
